export default __webpack_public_path__ + "static/media/wb-9.08472af3.webp";